const isMobileApp = () => {
  const queryString = window.location.search;

  const params = new URLSearchParams(queryString);

  return params.get('mobile_app') === 'true';
};

export default isMobileApp;
